<template>
  <div>
    <!-- {{$t('message.title')}} -->
    <HomeHeaderNavBar></HomeHeaderNavBar>
    <HomeHeader></HomeHeader>
    <HomeContentAdvantage></HomeContentAdvantage>
    <HomeContentProducts></HomeContentProducts>
    <!-- <HomeContentExample></HomeContentExample> -->
    <!-- <HomeContentTeaching></HomeContentTeaching> -->
    <HomeContentSolution></HomeContentSolution>
    <!-- <HomeContentFeedback></HomeContentFeedback> -->
    <!-- <HomeContentNews></HomeContentNews> -->
    <!-- <HomeContentJoinUs></HomeContentJoinUs> -->
    <HomeFooter></HomeFooter>
    <!-- <Fixed></Fixed> -->

  </div>
</template>

<script>
import HomeHeaderNavBar from "./components/HeaderNavBar";
import HomeHeader from "./components/Header";
import HomeContentAdvantage from "./components/ContentAdvantage";
import HomeContentProducts from "./components/ContentProducts";
import HomeContentExample from "./components/ContentExample";
import HomeContentTeaching from "./components/ContentTeaching";
import HomeContentSolution from "./components/ContentSolution";
import HomeContentFeedback from "./components/ContentFeedback";
import HomeContentNews from "./components/ContentNews";
import HomeContentJoinUs from "./components/ContentJoinUs";
import HomeFooter from "./components/Footer";
import Fixed from "@/pages/fixed";

export default {
  name: "Home",
  components: {
    HomeHeaderNavBar,
    HomeHeader,
    HomeContentAdvantage,
    HomeContentProducts,
    HomeContentExample,
    HomeContentTeaching,
    HomeContentSolution,
    HomeContentFeedback,
    HomeContentNews,
    HomeContentJoinUs,
    HomeFooter,
    Fixed,
  },
};
</script>

<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue